import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type UserSelectedTheme = 'light' | 'dark' | 'system';
type Theme = 'light' | 'dark';

interface ThemeState {
  userSelectedTheme: UserSelectedTheme;
  setUserSelectedTheme: (theme: UserSelectedTheme) => void;
}

// 시스테 테마 가져오기
export const getSystemTheme = () => (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

// 테마를 DOM에 적용하기
const applyThemeToDOM = (theme: Theme) => document.documentElement.setAttribute('data-theme', theme);

const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      userSelectedTheme: 'light',
      setUserSelectedTheme: (theme: UserSelectedTheme) => {
        set({ userSelectedTheme: theme });
        applyThemeToDOM(theme === 'system' ? getSystemTheme() : theme);
        Transition.handlePrefersColorSchemeChange();
      },
    }),
    {
      name: 'themeStore',
      partialize: (state) => ({
        userSelectedTheme: state.userSelectedTheme,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          applyThemeToDOM(state.userSelectedTheme === 'system' ? getSystemTheme() : (state.userSelectedTheme as Theme));
          Transition.handlePrefersColorSchemeChange();
        }
      },
    }
  )
);

// 시스템 테마 변경 감지
if (typeof window !== 'undefined' && window.matchMedia) {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (useThemeStore.getState().userSelectedTheme === 'system') {
      applyThemeToDOM(getSystemTheme());
      Transition.handlePrefersColorSchemeChange();
    }
  });
}

export default useThemeStore;
